"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBusinessObjectAssembler = void 0;
const tslib_1 = require("tslib");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const uuid_1 = require("uuid");
const ModelCommon_1 = require("./model/ModelCommon");
const debug = process.env.REACT_APP_DEBUG === 'false' && !process.env.AWS_SESSION_TOKEN && false;
const filter = (ModelClasses) => {
    const filtered = Object.entries(ModelClasses).filter(([k, c]) => {
        const descriptor = Object.getOwnPropertyDescriptor(ModelClasses, k);
        return descriptor?.get ? descriptor.get().prototype instanceof ModelCommon_1.ModelCommon : false;
    });
    const filteredModel = Object.fromEntries(filtered);
    debug && console.log(`Assembler filtered `, filteredModel);
    debug && console.log(`From: `, ModelClasses);
};
const createBusinessObjectAssembler = (ModelClasses) => createBusinessObjectAssemblerFiltered(/*filter(ModelClasses) */ ModelClasses);
exports.createBusinessObjectAssembler = createBusinessObjectAssembler;
const createBusinessObjectAssemblerFiltered = (ModelClasses) => class BusinessObjectAssembler {
    constructor() {
        // getUserAttributes for a non type object
        this.getUserAttributes = (ob) => {
            let userAttributes = {};
            Object.entries(ob).forEach(([k, v]) => {
                let type = 'String';
                if (typeof v === 'number')
                    type = 'Number';
                else if (typeof v === 'string')
                    type = 'String';
                else if (typeof v === 'boolean')
                    type = 'Boolean';
                else if (v && v instanceof Object) {
                    if (v instanceof Date)
                        type = 'Date';
                }
                userAttributes[k] = { type };
            });
            return userAttributes;
        };
        this.getZombieFromPrimaryKey = (pk, others) => {
            const [type, ...idOthers] = pk.split(':');
            const id = idOthers.join(':');
            const zombieInstance = { type, id, sk: `${type}:${id}`, pk: `${type}:${id}`, ...others };
            return zombieInstance;
        };
        this.ghostify = (vob) => {
            const newKeys = `${vob.type}:${config_1.default.app.ghostUuid}`;
            return { ...vob, sk: newKeys, pk: newKeys, id: config_1.default.app.ghostUuid };
        };
        this.reidentify = (vob, id) => {
            const newKeys = `${vob.type}:${id}`;
            const newZombie = { ...vob, sk: newKeys, pk: newKeys, id };
            const instance = this.getInstance(newZombie);
            return instance ?? newZombie;
        };
        debug && console.log('Model Classes', ModelClasses);
    }
    getClass(item) {
        if (typeof item === 'object' && item.type)
            return item.type ? ModelClasses[item.type] : undefined;
        else if (typeof item === 'string')
            return ModelClasses[item] ? ModelClasses[item] : undefined;
        else
            return undefined;
    }
    isInstance(item) {
        return this.getClass(item) !== undefined;
    }
    assignNewId(item) {
        debug && console.log('Item in assign new id');
        if (!item.id)
            item.id = (0, uuid_1.v4)();
        return item;
    }
    // getInstance is overloaded to allow pojos {id: 'xx', type: 'someType'} or just return clone if class instance already
    getInstance(item) {
        debug && console.log('Object in assembler', item);
        if (!item)
            throw new Error('No item was provided to BusinessObjectAssembler getInstance\n item === undefined | null');
        if (item.type === undefined)
            throw new Error('No type on: ' + JSON.stringify(item));
        if (!item.id)
            this.assignNewId(item);
        const clazz = this.getClass(item);
        let instance = undefined;
        if (clazz !== undefined) {
            if (item.sk && item.pk) {
                if (item instanceof clazz) {
                    debug && console.log('item already instance of ', clazz.name);
                    instance = item;
                }
                else {
                    debug && console.log(`item not an instance of ${clazz.name} but is possible`, item);
                    instance = new clazz(item);
                    debug && console.log('item Created ', instance);
                }
            }
            else {
                debug && console.log('No pk and sk for ', item);
                if (item.id && clazz.prototype) {
                    instance = new clazz(item);
                    debug && console.log('item Created ', clazz.name);
                }
            }
        }
        else {
            debug && console.log('No class for ', item.type ?? item.sk);
            debug && console.log('classes are', Object.keys(ModelClasses));
            if (debug && Object.keys(ModelClasses).includes(item.type)) {
                console.log(`Model[${item.type}] is`, ModelClasses[item.type]);
            }
            debug && console.log('WARN: Allowing override model', item.type);
            instance = new ModelCommon_1.ModelCommon(item.type, item);
        }
        debug && console.log('assembler returning ', instance);
        return instance;
    }
    getSafeId(item) {
        return item.type && item.id ? item.type + ':' + item.id : null;
    }
    getInstanceFromPrimaryKey(pk, others) {
        const zombieInstance = this.getZombieFromPrimaryKey(pk, others);
        return this.getInstance(zombieInstance);
    }
    getDynamoKeyFromPrimaryKey(pk) {
        const zombieInstance = { pk, sk: pk };
        return zombieInstance;
    }
    isThingSubType(typeId) {
        //because we don't expect some clever prototype reflection to work in Webpack
        return ['Horse', 'Boat', 'etc'].includes(typeId); //TODO either move to config or do by reflection
    }
    // where ob has key and key is an array or similar obs
    flatten(ob, key, res = []) {
        if (ob[key] instanceof Array) {
            ob[key].forEach((ob) => this.flatten(ob, key, res));
        }
        res.push(ob);
        return res;
    }
    // probably like flat, except need to provide initial res array
    flattenArray(x, res) {
        if (x instanceof Array) {
            x.forEach((y) => this.flattenArray(y, res));
        }
        else {
            res.push(x);
        }
    }
    assembleFromArray(arr) {
        arr = arr.map((item) => this.getInstance(item)).filter((item) => item !== undefined);
        let top = arr.find((item) => item.pk === item.sk);
        top = top === undefined ? null : top;
        arr.sort((a, b) => (a.name < b.name ? 0 : 1));
        if (top)
            arr.forEach((item) => {
                //console.log('Item in assemble: ', item)
                if (item.pk !== item.sk) {
                    const typeArrayName = item.type;
                    if (top && top[typeArrayName] === undefined)
                        top[typeArrayName] = [];
                    if (top)
                        top[typeArrayName].push(item);
                    // remove when working
                    if (this.isThingSubType(item.type)) {
                        if (top && top.Thing === undefined)
                            top.Thing = [];
                        if (top)
                            top.Thing.push(item);
                    }
                }
            });
        return top ? top : arr.length === 1 ? arr[0] : arr;
    }
    //revised to always return array and to match all
    assembleFromArray2(arr) {
        const unsortedInstance = arr.map((item) => this.getInstance(item)).filter((item) => item !== undefined);
        const sortedInstances = unsortedInstance.sort((a, b) => (a.name < b.name ? 0 : 1));
        let idMap = {};
        let parentsMap = {};
        sortedInstances.forEach((item) => {
            idMap[item.sk] = item;
            if (item.pk === item.sk)
                parentsMap[item.sk] = item;
        });
        const keys = Object.keys(idMap);
        debug && console.log('Keys: ', keys);
        sortedInstances.forEach((item) => {
            if (item.sk !== item.pk && keys.includes(item.pk)) {
                const parent = idMap[item.pk];
                const typeArrayName = item.type;
                if (parent[typeArrayName] === undefined) {
                    parent[typeArrayName] = [];
                }
                parent[typeArrayName].push(item);
            } /*if (item.sk != this.getSafeId(item))*/
            else {
                parentsMap[item.sk] = item;
            }
        });
        debug && console.log('Parents Map', parentsMap);
        return Object.values(parentsMap);
    }
    // May or may not have the same effect as assembleFromArray2 but without sort and get intance
    parent(objectArr) {
        let skMap = {};
        objectArr.forEach((o) => {
            if (o.sk)
                skMap[o.sk] = o;
        });
        debug && console.log('Map', skMap);
        objectArr.forEach((o) => {
            if (o.sk && o.pk && o.sk !== o.pk && o.type && skMap[o.pk]) {
                let t = skMap[o.pk];
                const typeArrayName = o.type;
                if (!t[typeArrayName])
                    t[typeArrayName] = [];
                if (t[typeArrayName].findIndex((tx) => tx && tx.sk && tx.sk === o.sk) === -1) {
                    t[typeArrayName].push(o);
                    delete skMap[o.sk];
                }
                // remove when working
                if (this.isThingSubType(o.type)) {
                    if (!t.Thing)
                        t.Thing = [];
                    if (t.Thing.findIndex((tx) => tx && tx.sk && tx.sk === o.sk) === -1) {
                        t.Thing.push(o);
                        delete skMap[o.sk];
                    }
                }
            }
        });
        return Object.values(skMap);
    }
};
